module.exports = __webpack_public_path__ + "img/big_pic.e8bef7d3.webp";